import axios from 'axios';
import { parse } from "content-disposition-header";
import i18n from 'src/i18n/i18n';
import router from 'src/router';
import SnackbarUtils from './SnackbarUtilsConfigurator';

const BASE_URL = 'https://api.cimarronftest.sokocloud.com';

const ROUTES = {
    BASE: BASE_URL,
    GET_FILE: BASE_URL + '/api/get-file/'
}

let onUnauthenticatedCallback;

const http = axios.create({
    baseURL: ROUTES.BASE,
    headers: {
        "X-requested-With": "XMLHttpRequest",
    },
    withCredentials: true
});
const getCookie = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

http.interceptors.request.use((config) => {
    const token = getCookie('XSRF-TOKEN');
    if (token) {
        config.headers['X-XSRF-TOKEN'] = token;
    }
    return config;
});
  
http.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }

        switch (error.response?.status) {
            case 403:
                if (error.response.data.exception !== 'Illuminate\\Routing\\Exceptions\\InvalidSignatureException') {
                    router.navigate('/status/403');
                }
                break;

            case 419:
                if (error.response.data.message == 'CSRF token mismatch.') {
                    await http.get("sanctum/csrf-cookie")
                    .then(()=>{
                        SnackbarUtils.success('Se ha renovado la sesión, vuelve a intentar.');
                    })
                    .catch((error) => {
                        SnackbarUtils.error('Hubo un problema al obtener csrf-cookie');
                    });
                }
                break;

            case 401:
                onUnauthenticatedCallback();
                throw new axios.Cancel(i18n.t('STATUS.401.MESSAGE'));

            default:
                break;
        }

        return Promise.reject((error.response && error.response.data) || error);
    }
);

const downloadFile = (url) => {
    http.get(url, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = 'unknown';
        if (response.headers['content-disposition']) {
            const contentDisposition = parse(response.headers['content-disposition']);
            filename = contentDisposition.parameters.filename ?? filename;
        }
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    });
}

const buildFormData = (formData, data, parentKey?) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;
    formData.append(parentKey, value);
  }
}

const setUnauthenticatedCallback = (onUnauthenticatedCallbackFn: Function) => {
    onUnauthenticatedCallback = onUnauthenticatedCallbackFn;
}

const onInvalidSubmitHandler = () => {
    SnackbarUtils.error('Hubo un error, revisa los datos del formulario');
}

export default http;
export { BASE_URL, downloadFile, ROUTES, setUnauthenticatedCallback, onInvalidSubmitHandler, buildFormData };
